import React from "react";
import Avatar from "../Avatar";
import S from "./User.styled";
export default function User({ user, isChannelMemberListOpen, isModerator, }) {
    if (!user)
        return null;
    return (React.createElement(S.Wrapper, null,
        React.createElement(Avatar, { src: user.image, alt: user.name }),
        React.createElement(S.Label, { htmlFor: `user-${user.id}` }, user.name),
        isChannelMemberListOpen && isModerator && (React.createElement(S.ModeratorBadge, null, "Moderator"))));
}
//# sourceMappingURL=User.js.map